import React, { useState, useEffect } from 'react';
import '../Dropdown/Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';

export default function CancelarNota() {
  const [notasCancelaveis, setNotasCancelaveis] = useState([]);
  const [notaSelecionada, setNotaSelecionada] = useState('');
  const [motivoCancelamento, setMotivoCancelamento] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');

  useEffect(() => {
    carregarNotasCancelaveis();
  }, []);

  const apiCall = async (endpoint, options = {}) => {
    const urls = [
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`
    ];

    for (const url of urls) {
      try {
        console.log(`Tentando conectar em: ${url}`);
        const token = getAuthToken();
        const optionsWithAuth = { ...options, headers: { ...(options.headers || {})} };
        if (token) optionsWithAuth.headers['Authorization'] = 'Bearer ' + token;
        const response = await fetch(url, optionsWithAuth);
        if (response.ok) {
          console.log(`✅ Sucesso em: ${url}`);
          return await response.json();
        }
        const errorText = await response.text();
        console.log(`❌ Falha em: ${url} - Status: ${response.status} - ${errorText}`);
        if (url === urls[urls.length - 1]) {
          throw new Error(errorText || `Erro HTTP ${response.status}`);
        }
      } catch (error) {
        console.log(`❌ Erro em: ${url} - ${error.message}`);
        if (url === urls[urls.length - 1]) {
          throw error;
        }
      }
    }
  };

  const carregarNotasCancelaveis = async () => {
    try {
      setLoading(true);
      setErro('');
      
      // Buscar todas as notas fiscais
      const data = await apiCall('NotaFiscal');
      const lista = Array.isArray(data) ? data : [];
      
      // Filtrar apenas as que podem ser canceladas (Pendente, Rejeitada, Erro)
      // Segundo a regra do backend: NFs autorizadas NÃO podem ser canceladas
      const cancelaveis = lista.filter(nota => {
        const status = nota.status || nota.Status || '';
        const podeCancelar = nota.podeCancelar || nota.PodeCancelar;
        
        // Se o backend já retorna podeCancelar, usar isso
        if (podeCancelar !== undefined) {
          return podeCancelar === true;
        }
        
        // Senão, verificar status manualmente
        const statusCancelaveis = ['Pendente', 'Rejeitada', 'Erro'];
        return statusCancelaveis.includes(status);
      });
      
      setNotasCancelaveis(cancelaveis);
    } catch (err) {
      console.error('Erro ao carregar notas canceláveis:', err);
      setErro('Erro ao carregar notas fiscais. Verifique se o backend está rodando.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelar = async (e) => {
    e.preventDefault();
    
    if (!notaSelecionada) {
      setErro('Selecione uma nota fiscal para cancelar.');
      return;
    }

    if (!motivoCancelamento.trim()) {
      setErro('Informe o motivo do cancelamento.');
      return;
    }

    if (motivoCancelamento.trim().length < 15) {
      setErro('O motivo do cancelamento deve ter pelo menos 15 caracteres.');
      return;
    }

    try {
      setLoading(true);
      setErro('');
      setMensagem('');

      const resultado = await apiCall(`NotaFiscal/cancelar/${notaSelecionada}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          motivo: motivoCancelamento
        })
      });

      if (resultado.success) {
        setMensagem(`✅ Nota Fiscal #${resultado.notaFiscal.numero} cancelada com sucesso!`);
        setNotaSelecionada('');
        setMotivoCancelamento('');
        // Recarregar lista
        setTimeout(() => {
          carregarNotasCancelaveis();
          setMensagem('');
        }, 3000);
      } else {
        throw new Error(resultado.message || 'Erro ao cancelar nota fiscal.');
      }
    } catch (err) {
      console.error('Erro ao cancelar nota:', err);
      setErro(`Erro ao cancelar: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f0f0f0', 
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '800px',
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ 
          color: 'rgb(235, 133, 0)', 
          fontSize: '28px', 
          fontWeight: 'bold',
          marginBottom: '10px',
          textAlign: 'center'
        }}>
          Cancelar Nota Fiscal
        </h1>
        
        <div style={{
          background: '#fff3e0',
          border: '1px solid rgb(235, 133, 0)',
          borderRadius: '8px',
          padding: '15px',
          marginBottom: '25px'
        }}>
          <p style={{ 
            margin: 0,
            color: 'rgb(184, 98, 0)',
            fontSize: '14px',
            lineHeight: '1.6'
          }}>
            ⚠️ <strong>ATENÇÃO:</strong> Apenas notas fiscais com status <strong>Pendente</strong>, 
            <strong> Rejeitada</strong> ou <strong>Erro</strong> podem ser canceladas.
            <br />
            Notas fiscais já <strong>Autorizadas</strong> NÃO podem ser canceladas pelo sistema.
          </p>
        </div>

        {erro && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid #ef5350'
          }}>
            {erro}
          </div>
        )}

        {mensagem && (
          <div style={{
            background: '#e8f5e9',
            color: '#2e7d32',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid #66bb6a'
          }}>
            {mensagem}
          </div>
        )}

        <form onSubmit={handleCancelar}>
          <div style={{ marginBottom: '25px' }}>
            <label style={{ 
              display: 'block',
              marginBottom: '10px',
              color: '#333',
              fontWeight: '500',
              fontSize: '15px'
            }}>
              Nota Fiscal:
            </label>
            <select
              value={notaSelecionada}
              onChange={(e) => setNotaSelecionada(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                outline: 'none',
                cursor: 'pointer'
              }}
              required
            >
              <option value="">-- Selecione uma Nota Fiscal --</option>
              {notasCancelaveis.map((nota) => {
                const id = nota.id || nota.Id || nota.notaId;
                const numero = nota.numero || nota.Numero || '';
                const nomeCliente = nota.nomeCliente || nota.NomeCliente || nota.Cliente?.Nome || '';
                const status = nota.status || nota.Status || '';
                const valor = nota.valor || nota.Valor || nota.valorTotal || nota.ValorTotal || 0;
                
                return (
                  <option key={id} value={id}>
                    NF #{numero} - {nomeCliente} - Status: {status} - R$ {Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </option>
                );
              })}
            </select>
            
            {notasCancelaveis.length === 0 && !loading && (
              <p style={{ 
                marginTop: '10px', 
                color: '#666', 
                fontSize: '14px',
                fontStyle: 'italic'
              }}>
                Nenhuma nota fiscal disponível para cancelamento.
              </p>
            )}
          </div>

          <div style={{ marginBottom: '25px' }}>
            <label style={{ 
              display: 'block',
              marginBottom: '10px',
              color: '#333',
              fontWeight: '500',
              fontSize: '15px'
            }}>
              Motivo do Cancelamento: <span style={{ color: '#d32f2f' }}>*</span>
            </label>
            <textarea
              value={motivoCancelamento}
              onChange={(e) => setMotivoCancelamento(e.target.value)}
              placeholder="Informe o motivo do cancelamento (mínimo 15 caracteres)"
              rows="4"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                outline: 'none',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
              required
              minLength="15"
            />
            <div style={{ 
              textAlign: 'right', 
              fontSize: '13px', 
              color: motivoCancelamento.length < 15 ? '#d32f2f' : '#666',
              marginTop: '5px'
            }}>
              {motivoCancelamento.length} / 15 caracteres mínimos
            </div>
          </div>

          <div style={{ 
            display: 'flex', 
            gap: '15px', 
            justifyContent: 'flex-end',
            marginTop: '30px'
          }}>
            <button
              type="button"
              onClick={() => window.history.back()}
              style={{
                padding: '12px 30px',
                fontSize: '15px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                background: 'white',
                color: '#666',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.background = '#f5f5f5'}
              onMouseLeave={(e) => e.target.style.background = 'white'}
            >
              Voltar
            </button>
            
            <button
              type="submit"
              disabled={!notaSelecionada || motivoCancelamento.length < 15 || loading}
              style={{
                padding: '12px 30px',
                fontSize: '15px',
                border: 'none',
                borderRadius: '6px',
                background: notaSelecionada && motivoCancelamento.length >= 15 && !loading ? '#d32f2f' : '#ccc',
                color: 'white',
                cursor: notaSelecionada && motivoCancelamento.length >= 15 && !loading ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (notaSelecionada && motivoCancelamento.length >= 15 && !loading) {
                  e.target.style.background = '#b71c1c';
                }
              }}
              onMouseLeave={(e) => {
                if (notaSelecionada && motivoCancelamento.length >= 15 && !loading) {
                  e.target.style.background = '#d32f2f';
                }
              }}
            >
              {loading ? 'Cancelando...' : 'Cancelar Nota Fiscal'}
            </button>
          </div>
        </form>
      </div>

      <LoadingOverlay isLoading={loading} message="Processando cancelamento..." />
    </div>
  );
}
